import { FileBasic } from '@commenda/types/src/file/types';
import type { TransactionSourcePlatform } from '../../sales-tax/types';
import { JobEntity, JobOperation, JobStatus } from '../../new-sales-tax/job/types';

export type TIndirectTaxProduct = {
  id: string;
  sku: string;
  name: string;
  description: string;
  taxCode: string;
  sourcePlatform: TransactionSourcePlatform | null;
  sourcePlatformId: string;
  createdAt: string;
};

export type TIndirectTaxProductTaxCode = {
  code: string;
  description: string;
  additionalInfo: string;
};

type ColumnMapping = {
  fromColumn: string;
  toColumn: string;
};

export interface TIndirectTaxBulkUploadProps {
  file: FileBasic;
  corporationId: number;
  columnMapping?: ColumnMapping[];
  updateProtectedColumns?: boolean;
}

interface BulkJobResponse {
  id: string;
  org_id: string;
  corporation_id: string;
  entity: JobEntity;
  operation: JobOperation;
  status: JobStatus;
  file_name: string;
  failure_reasons: string[] | null;
}

export interface TIndirectTaxBulkUploadResponse {
  data: {
    job: BulkJobResponse;
  };
  message: string;
}

export type TIndirectTaxProductsBulkUpdateFilterProps = {
  corporation_id: number;
  product_ids?: string[];
  excluded_ids?: string[];
  search_term?: string;
  source_platform_id?: string;
  tax_codes?: string[];
};

export type TIndirectTaxProductsBulkUpdateFieldsProps = {
  tax_code?: string;
};

export type TIndirectTaxProductsBulkUpdateProps = {
  update: TIndirectTaxProductsBulkUpdateFieldsProps;
  filters: TIndirectTaxProductsBulkUpdateFilterProps;
};

export type TIndirectTaxProductsBulkDeleteProps = {
  filters: TIndirectTaxProductsBulkUpdateFilterProps;
};

export enum TIndirectTaxExportDataDeliveryType {
  EMAIL = 'email',
}

export interface TIndirectTaxExportDataDeliveryOptions {
  type: TIndirectTaxExportDataDeliveryType;
  recipients?: string[];
}

export interface TIndirectTaxBulkExportProductsRequest {
  filters: TIndirectTaxProductsBulkUpdateFilterProps;
  delivery: TIndirectTaxExportDataDeliveryOptions;
}

export interface TIndirectTaxBulkExportProductsResponse {
  message: string;
}

// --- Hook response / param types (consolidated from hook files) ---

export interface IndirectTaxProductsResponse {
  data: TIndirectTaxProduct[];
  nextCursor: string | null;
  totalProducts: number;
}

export interface UseIndirectTaxProductsParams {
  token?: string;
  filters: {
    corporationId?: number;
    tax_codes?: string[];
  };
  cursor?: string | null;
  limit?: number;
  search_term?: string;
}

export interface IndirectTaxProductResponse {
  data: TIndirectTaxProduct;
}

export interface UseIndirectTaxProductParams {
  token?: string;
  productId?: string;
  corporationId?: number;
}

export interface IndirectTaxProductTaxCodesResponse {
  data: {
    taxCodes: TIndirectTaxProductTaxCode[];
  };
}

export interface UseIndirectTaxProductTaxCodesParams {
  token?: string;
  filters: {
    corporationId?: number;
  };
}

// --- Mutation types (consolidated from mutation files) ---

export type CreateIndirectTaxProductProps = {
  name: string;
  tax_code: string;
  description?: string;
  sku: string;
};

export type UpdateIndirectTaxProductProps = {
  id?: string;
  name?: string;
  tax_code?: string;
  sku?: string;
  description?: string;
};

export interface ICommendaProduct {
  id: string;
  name: string;
  sku: string;
  description: string;
  taxCode: string;
}
